var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.imgcss},[_c('div',{class:_vm.customer},[_c('a',{attrs:{"target":"_blank","href":_vm.data.filePath}},[_c('img',{attrs:{"src":_vm.data.previewImageUrl},on:{"load":_vm.getWidth}})]),_vm._v(" "),_c('div',{staticClass:"play-icon"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23bf46f0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoMessage.vue
// module id = null
// module chunks = 